"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Pagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PageSizeDropdown = function PageSizeDropdown(_ref) {
  var theme = _ref.theme,
      settings = _ref.settings,
      options = _ref.options,
      updatePageSize = _ref.updatePageSize;
  if (!updatePageSize) return null;
  return _react["default"].createElement("div", {
    className: theme.dropdown
  }, _react["default"].createElement(_Dropdown["default"], {
    value: settings.pageSize,
    onChange: function onChange(item) {
      return updatePageSize(item.value);
    },
    source: options
  }));
};

var Pagination =
/*#__PURE__*/
function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          settings = _this$props.settings,
          nextPage = _this$props.nextPage;
      var lastPage = Math.ceil(settings.total / settings.pageSize);
      var startResult = settings.currentPage > 1 ? (settings.currentPage - 1) * settings.pageSize + 1 : 1;
      var endResult = settings.currentPage === lastPage ? settings.total : startResult + settings.pageSize - 1;
      return _react["default"].createElement("div", {
        className: theme.container
      }, _react["default"].createElement(PageSizeDropdown, this.props), _react["default"].createElement("div", {
        className: theme.resultInfo
      }, "".concat(startResult, "-").concat(endResult, " of ").concat(settings.total)), _react["default"].createElement("button", {
        onClick: function onClick() {
          return nextPage(settings.currentPage - 1);
        },
        disabled: settings.currentPage - 1 < 1,
        className: theme.button
      }, _react["default"].createElement("i", {
        className: "material-icons"
      }, "chevron_left")), _react["default"].createElement("button", {
        onClick: function onClick() {
          return nextPage(settings.currentPage + 1);
        },
        disabled: settings.currentPage >= settings.total / settings.pageSize,
        className: theme.button
      }, _react["default"].createElement("i", {
        className: "material-icons"
      }, "chevron_right")));
    }
  }]);

  return Pagination;
}(_react.Component);

exports.Pagination = Pagination;

_defineProperty(Pagination, "defaultProps", {
  options: [{
    value: 10,
    label: '10'
  }, {
    value: 25,
    label: '25'
  }, {
    value: 50,
    label: '50'
  }, {
    value: 100,
    label: '100'
  }]
});

;

var _default = (0, _ThemeProvider.applyTheme)('Pagination', Pagination);

exports["default"] = _default;